<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
      <ChromeSpeechToTextTextarea rows="4" max-rows="10" v-model="text" />

      <ErrorsMessages :errors="errors" />
    </div>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-text-right"
    >
      <confirmation-dialog
        headerClass="modal-header"
        message-title="COMPLEMENTAR"
        :message-body="`Após complementar, não será possível alterar o complemento. Confirmar?`"
        open-text="COMPLEMENTAR"
        open-class="btn-save"
        open-left-icon="fa-check"
        @yes="complementary()"
        :loading="loading"
        :disabled="loading"
      />
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import ChromeSpeechToTextTextarea from "../Components/ChromeSpeechToTextTextarea";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import ErrorsMessages from "../Components/ErrorsMessages";

export default {
  name: "Complement",

  components: {
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
    ErrorsMessages,
  },

  props: {
    evolution_id: Number,
  },

  data() {
    return {
      text: "",

      loading: false,

      errors: [],
    };
  },

  methods: {
    async complementary() {
      try {
        this.loading = true;

        let { evolution_id, text } = this;

        let params = { evolution_id, text };

        const response = await api.post(
          "/rest-home/evolution/complement",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("success");

          this.text = "";

          this.errors = [];

          this.$bvModal.hide("modalComplement");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
